import { PurchaseOptionType } from '@/types/productServerApi';
import { useModuleConfigurator } from '@/shared/product/details/ui/module-configurator/useModuleConfigurator';
import { useRouteQuery } from '@/core/browser/route-query.composable';
import { QueryKeys } from '@/shared/config/route-query.config';
import useTEMPB2BFeatureBasket from '@/b2b/basket/useTEMPB2BFeatureBasket';

export const webApiMessageId = 'expressDeliveryWebApiMessage';
const { moduleConfiguratorTileData } = useModuleConfigurator();
const { addRegular, addPickAndPack, addOrUpdateModuleConfiguration } = useTEMPB2BFeatureBasket();

export function useAddToBasket() {
    const configurationId = useRouteQuery(QueryKeys.PDPConfigurationId);

    const addToBasket = async(id: string, purchaseType: PurchaseOptionType, quantity: number = 1, delta = true, relatedItemId?: number) => {
        switch (purchaseType) {
        case PurchaseOptionType.B2BExpress:
            await addPickAndPack(id, quantity, delta, relatedItemId, webApiMessageId);
            break;
        case PurchaseOptionType.ModuleConfiguration:
            await addOrUpdateModuleConfiguration(configurationId.value, moduleConfiguratorTileData.value);
            break;
        default:
            await addRegular(id, quantity, delta, relatedItemId);
        }
    };

    return {
        addToBasket,
    };
}
